import React, { useState } from "react";
import "./forms.css";
import WebFrom from "./WebFrom";
import MarketingForm from "./MarketingForm";

export default function Forms() {
  const [web, setWeb] = useState(true);
  return (
    <div className={"formOuterContainer"}>
      <div className={"formToggleTabContainer"}>
        <div
          className={`${"formToggleTab"} ${web ? "formActiveTab" : ""}`}
          onClick={() => setWeb(true)}
        >
          Android / Web
        </div>
        <div
          className={`${"formToggleTab"} ${!web ? "formActiveTab" : ""}`}
          onClick={() => setWeb(false)}
        >
          Marketing
        </div>
      </div>
      <div className={"formContainer"}>
        {web ? <WebFrom /> : <MarketingForm />}
      </div>
    </div>
  );
}
